export default {
  label: "Twitter",
  script: `import { createSession } from '@plutoxyz/automation';
import { chromium } from 'playwright-core';

const session = await createSession();

const input = await session.prompt({
  title: 'Login to Twitter',
  description: 'Enter your Twitter credentials to prove your data',
  icon: 'twitter.com',
  prompts: [
    {
      label: 'Email or Username',
      type: 'text',
      attributes: {
        min_length: 3,
        max_length: 3,
        placeholder: 'Email or Phone Number',
      },
    },
    {
      label: 'Password',
      type: 'password',
      attributes: {
        placeholder: 'Password',
      },
    },
  ],
});

const browser = await chromium.connectOverCDP(await session.cdp());
const context = browser.contexts()[0];
const page = context.pages()[0];

await page.goto('https://x.com/i/flow/login');

await page.getByRole('textbox', { name: 'email' }).fill(input[0]);
await page.getByRole('button', { name: 'Next' }).click();

await page.getByRole('textbox', { name: 'Password' }).fill(input[1]);
await page.getByRole('button', { name: 'Log in' }).click();

await page.waitForLoadState('networkidle');

const security = await page
  .getByText('Check your email')
  .isVisible()
  .catch(() => false);
if (security) {
  await page.waitForTimeout(2000);
  await page.getByRole('textbox', { name: 'Confirmation code' }).click();

  const otp = await session.prompt({
    title: 'Enter one time code',
    description: 'Enter the one time code sent to your email',
    icon: 'twitter.com',
    prompts: [
      {
        label: 'Code',
        type: 'text',
        attributes: {
          min_length: 6,
          max_length: 6,
          placeholder: 'Code',
        },
      },
    ],
  });

  await page.getByRole('textbox', { name: 'Confirmation code' }).fill(otp[0]);
  await page.getByRole('button', { name: 'Next' }).click();
}

await page.waitForLoadState('domcontentloaded');

const getStarted = page.getByText('Get Started');
const isGetStartedVisible = await getStarted.isVisible();
if (isGetStartedVisible) {
  getStarted.click();
}

// assert that the user is logged in
const loggedIn = await page
  .getByText("What's happening", { exact: true })
  .isVisible()
  .catch(() => false);
console.log('Logged in:', loggedIn);
await session.prove('logged_in', loggedIn);

await session.close();
`,
};
